import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useParams } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';

import { useEditPlanOnMapModalStore } from './EditPlanOnMapStore';

import { EditPlanOnMapFormValues, editPlanOnMapSchema } from 'api/InteractiveMap/types';
import { MLInput } from 'components/Input/Input';
import usePutInteractiveMapPlan from 'hooks/InteractiveMap/usePutInteractiveMapPlan';

const EditPlanOnMapModal = () => {
  const { t } = useTranslation();

  const { isOpen, onCompleteVulClose, planSlug } = useEditPlanOnMapModalStore();
  const { putInteractiveMapPlan } = usePutInteractiveMapPlan();

  const { slug } = useParams();

  const { control, handleSubmit: rhfHandleSubmit } = useForm<EditPlanOnMapFormValues>({
    resolver: zodResolver(editPlanOnMapSchema),
    defaultValues: {
      title: '',
      uploaded_file: undefined,
    },
  });

  const onSubmit = (data: EditPlanOnMapFormValues) => {
    if (!data.uploaded_file) {
      enqueueSnackbar(t('MapModals.editPlanOnMapModal.error'));
      return;
    }
    const payload = {
      title: data.title,
      uploaded_file: data.uploaded_file,
      site_slug: slug as string,
      slug: planSlug,
    };

    putInteractiveMapPlan(payload, {
      onSuccess: () => {
        enqueueSnackbar(t('MapModals.editPlanOnMapModal.changePlan'));
        onCompleteVulClose();

        window.location.reload();
      },
      onError: (error: any) => {
        if (error?.response?.data?.name) {
        } else {
          enqueueSnackbar(t('MapModals.editPlanOnMapModal.error'));
        }
      },
    });
  };

  return (
    <div>
      <Modal isOpen={isOpen} size="md">
        <ModalHeader className="border-bottom pb-3 pt-3 ">
          <p className="text-purple m-0">{t('MapModals.editPlanOnMapModal.title')}</p>
        </ModalHeader>
        <ModalBody>
          <div className="row mb-2">
            <div className="col-xl-12 mb-2">
              <Controller
                control={control}
                name="title"
                render={({ field, fieldState: { error } }) => (
                  <MLInput {...field} error={error?.message} label={t('MapModals.editPlanOnMapModal.namePlan')} />
                )}
              />
            </div>
            <div className="col-xl-12">
              <Controller
                control={control}
                name="uploaded_file"
                render={({ field: { value, onChange, ...fieldProps }, fieldState: { error } }) => (
                  <MLInput
                    {...fieldProps}
                    type="file"
                    label={t('MapModals.editPlanOnMapModal.planPhoto')}
                    placeholder="Plan"
                    error={error?.message}
                    value={undefined}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const file = e.target.files ? e.target.files[0] : null;
                      onChange(file);
                    }}
                  />
                )}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="w-100 d-flex justify-content-end">
            <Button
              className="btn btn-ghost-danger"
              onClick={() => {
                onCompleteVulClose();
              }}
            >
              {t('Modals.delete-modal.cancel')}
            </Button>

            <Button className="btn btn-ghost-success" onClick={rhfHandleSubmit(onSubmit)}>
              {t('TrapModals.confirm')}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default EditPlanOnMapModal;
